/**
 *
 */
function loadTfSvgSprite() {
	if (!document.documentElement.classList.contains('tf')) {
		return;
	}

	if (document.documentElement.hasAttribute('data-tf-svg-sprite-loaded')) {
		return;
	}

	const useElements = [...document.querySelectorAll('use')];
	const spriteUses = useElements.filter((useElement) => {
		const href = useElement.getAttribute('href') || useElement.getAttribute('xlink:href');

		return typeof href === 'string' && href.includes('lta-icons.svg');
	});

	if (spriteUses.length === 0) {
		return;
	}

	const fullHref = spriteUses[0].getAttribute('href') || spriteUses[0].getAttribute('xlink:href');
	if (!fullHref) {
		return;
	}

	const svgUrl = fullHref.split('#')[0];
	if (!svgUrl) {
		return;
	}

	document.documentElement.dataset.tfSvgSpriteLoaded = 'pending';

	fetch(svgUrl)
		.then(function (response) {
			return response.text();
		})
		.then(function (data) {
			if (!document.body) {
				return;
			}

			const div = document.createElement('div');
			div.setAttribute('aria-hidden', 'true');
			div.style.cssText = 'position:absolute;width:0;height:0;overflow:hidden;';
			div.innerHTML = data;
			document.body.insertBefore(div, document.body.firstChild);

			for (const useElement of spriteUses) {
				const href = useElement.getAttribute('href') || useElement.getAttribute('xlink:href');
				if (!href || !href.includes('#')) {
					continue;
				}

				const fragment = href.split('#')[1];
				const symbol = div.querySelector('#' + fragment);
				if (!symbol) {
					continue;
				}

				const parentSvg = useElement.closest('svg');
				if (!parentSvg) {
					continue;
				}

				// Copy viewBox from symbol to parent SVG if not already set
				if (!parentSvg.getAttribute('viewBox') && symbol.getAttribute('viewBox')) {
					parentSvg.setAttribute('viewBox', symbol.getAttribute('viewBox'));
				}

				// Replace the use element with the symbol's inner contents
				parentSvg.innerHTML = symbol.innerHTML;
			}

			document.documentElement.dataset.tfSvgSpriteLoaded = 'true';
		})
		.catch(function (error) {
			document.documentElement.removeAttribute('data-tf-svg-sprite-loaded');
			console.warn('SVG sprite load failed:', error);
		});
}

loadTfSvgSprite();
